function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import TsVod from 'vod-js-sdk-v6';
import { HTTPClient } from '@weike/toolkit';
export var WKVOD = /*#__PURE__*/function () {
  function WKVOD(baseURL, options) {
    if (options === void 0) {
      options = {};
    }

    this.baseURL = baseURL;

    _defineProperty(this, "tsVod", void 0);

    _defineProperty(this, "http", void 0);

    _defineProperty(this, "uploadAuthOption", void 0);

    _defineProperty(this, "signature", void 0);

    _defineProperty(this, "isProduction", void 0);

    this.http = this.createHTTPClient(this.baseURL);
    this.isProduction = process.env.REACT_APP_RUNTIME === 'production';
    this.tsVod = new TsVod(_extends({
      getSignature: this.getSignature.bind(this)
    }, options));
  }

  var _proto = WKVOD.prototype;

  _proto.init = /*#__PURE__*/function () {
    var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file, options) {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.uploadAuthOption = _extends({
                SubAppId: !this.isProduction ? 1400232164 : undefined,
                filename: file.name
              }, options);
              _context.next = 3;
              return this.http.post('/v1/integration/wk_media_manager/outer/media_resource.upload_with_vod.get', this.uploadAuthOption);

            case 3:
              res = _context.sent;
              this.signature = res.data.signature;
              return _context.abrupt("return", _extends({}, res.data, {
                sub_app_id: this.uploadAuthOption.SubAppId
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init(_x, _x2) {
      return _init.apply(this, arguments);
    }

    return init;
  }();

  _proto.upload = function upload(file, cover) {
    var uploadOptions = {
      mediaFile: file
    };

    if (cover) {
      uploadOptions.coverFile = cover;
    }

    var uploader = this.tsVod.upload(uploadOptions);
    return uploader;
  };

  _proto.getSignature = /*#__PURE__*/function () {
    var _getSignature = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.signature || '0');

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getSignature() {
      return _getSignature.apply(this, arguments);
    }

    return getSignature;
  }()
  /**
   * 传入baseURL创建http请求
   *
   * @private
   * @param {string} baseURL
   * @returns
   * @memberof WK_VOD
   */
  ;

  _proto.createHTTPClient = function createHTTPClient(baseURL) {
    return new HTTPClient({
      baseURL: baseURL
    }, '0000');
  };

  return WKVOD;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/vod/vod.js
// module id = 644
// module chunks = 4